import axios from 'axios'
import localData from '@/utility/localData'
const ConductorStore = {
  data: {

  },

  methods:
  {
    async doPublish(id, published) {
      const token = localData.methods.getLocalToken()
      let parms = 'conductorTypes/' + id
      return await axios.patch(parms, {
        isPublished: published
      }, { headers: { "Authorization": `Bearer ${token}` } }
      ).then(response => {
        return response.data
        //return response.data
      }).catch(error => {
        console.log('Error: ', error)
      });

    },
    delete(id) {
        const token = localData.methods.getLocalToken()
        let parms = 'conductorTypes/' + id
        return axios.delete(parms, { headers: { "Authorization": `Bearer ${token}` } }
        );

    },
    addConductorType(payload) {
      const token = localData.methods.getLocalToken()
      return axios.post('conductorTypes', payload, { headers: { "Authorization": `Bearer ${token}` } }
      );

    },
    editConductorType(id, title,feederType, resistance, reactan, peak, isPublished) {
      const token = localData.methods.getLocalToken()
      return axios.patch('conductorTypes/' + id, {
        title: title,
        feederType : feederType,
        resistanceOhmsPerKm: resistance,
        reactanceOhmsPerKm: reactan,
        peakCurrentCarryingCapacityAmps: peak,
        isPublished: isPublished
      }, { headers: { "Authorization": `Bearer ${token}` } }
      );
    }
  }
}
export default ConductorStore;